




































import Vue from 'vue'
import Component from 'vue-class-component';

/**
 * Widget básico incluido por defecto que muestra al usuario la hora del sistema
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class ClockWidget extends Vue {
    public counter = 0
    public mounted () {
        (function createSecondLines () {
            const clock = document.querySelector('.clock');
            let rotate = 0;

            const byFive = (n: number) => {
                return (n / 5 === (n / 5));
            };

            for (let i = 0; i < 30; i++) {
                const span = document.createElement('span');

                if (byFive(i)) {
                    span.className = 'fives';
                }

                span.style.transform = 'translate(-50%,-50%) rotate(' + rotate + 'deg)';
                clock!.appendChild(span);
                rotate += 6;
            }
        })();

        const setClock = () => {
            const time = new Date();

            const hours = time.getHours();
            const minutes = time.getMinutes();
            const seconds = time.getSeconds();

            const clock = {
                hours: document.querySelector('.hours') as HTMLElement,
                minutes: document.querySelector('.minutes') as HTMLElement,
                seconds: document.querySelector('.seconds') as HTMLElement,
            };

            const deg = {
                hours: 30 * hours + .5 * minutes,
                minutes: 6 * minutes + .1 * seconds,
                seconds: 6 * seconds,
            };

            clock.hours!.style.transform = 'rotate(' + deg.hours + 'deg)';
            clock.minutes!.style.transform = 'rotate(' + deg.minutes + 'deg)';
            clock.seconds!.style.transform = 'rotate(' + deg.seconds + 'deg)';

            const runClock = () => {
                deg.hours += 360 / 43200;
                deg.minutes += 360 / 3600;
                deg.seconds += 360 / 60;

                this.counter++

                clock.hours.style.transform = 'rotate(' + deg.hours + 'deg)';
                clock.minutes.style.transform = 'rotate(' + deg.minutes + 'deg)';
                clock.seconds.style.transform = 'rotate(' + deg.seconds + 'deg)';
            };

            setInterval(runClock, 1000);

            (function printDate () {
                const months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
                const print = time.getDate() + ' / ' + months[time.getMonth()];
                const output = document.querySelectorAll('output');

                [].forEach.call(output, (node: HTMLElement) => {
                    node.innerHTML = print;
                });
            })();

        }

        setClock()
    }
}
